import type { FaireProductEntity } from "../../entity_types/product";

export const p_8qq2djrhyj: FaireProductEntity = {
  token: "p_8qq2djrhyj",
  type: "product",
  name: "Blueberry Jasmine Non-Alcoholic Kombucha",
  brandToken: "b_s2jesyk5p9",
  brandName: "Walker Brothers",
  imageUrl: "https://cdn.faire.com/fastly/bda9a7a241daeb4f9d380354de369d1860ecb64a525d7180a0613cf1552a56d6.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/13c8a8e4b739826717d50e25ffe0a9cdad2d502dddc8fddad53ee94aaf205b1b.jpeg",
    "https://cdn.faire.com/fastly/f0466ed591ce1942a4aa1fe9724ef5b60516c491d737c8c1a8f09d92dcf114c3.jpeg",
    "https://cdn.faire.com/fastly/d23793bee084a9f02d76222b4c6943f609259faa71e2923a463fefab2eedd6cc.jpeg",
    "https://cdn.faire.com/fastly/2abbe596fca747a3dcc0813b3f5b1279107eceff0929864b3211c116232b7e09.jpeg",
    "https://cdn.faire.com/fastly/d97d615014b81ec092705829d701137d9e0e0d621821b386d9d025b39638da87.png"
  ],
  priceDollars: 2.25,
  description: "Organic blueberry purée intertwines with jasmine tea and a touch of lemon to reveal notes of fresh jam, white grape, and tart berry in this craft non-alcoholic kombucha. This best-selling kombucha is a great introductory beverage to customers who are new to kombucha.\n\n***Please note: This item is unpasteurized and must be kept refrigerated.***\n\nIngredients: Raw Kombucha (Filtered Water, Kombucha Culture, Black Tea*, Green Tea*, Jasmine Tea*, Cane Sugar*), Blueberry Purée*, Jasmine Tea*, Lemon Juice*\n*certified organic ingredients\n\nWalker Brothers Ginger craft kombucha is non-alcoholic, unpasteurized and rich in live probiotics, gluten-free, kosher pareve, and vegan.\n\nPackaged in an aluminum can for ease of recycling\n\nA healthy, non-alcoholic option for fall gatherings, tailgates, Halloween, Thanksgiving, Friendsgiving and holiday parties! A great mixer for drinks as well as a good snack pairing with chips and popcorn. ",
  tags: [],
  msrpDollars: 4.5,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-10-09T08:04:39.195Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
